import Api from '../../api/Api'

const profile = {
  //set namespace true
  namespaced: true,

  //state
  state: {},

  //mutations
  mutations: {},

  //actions
  actions: {
    update_pengguna({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('profile/update_pengguna', params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_akademik({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('profile/update_akademik', params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_email({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('profile/update_akun', params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_email_trainer({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('profile/update_email_trainer', params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    send_email_verification({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('profile/kirim_email_verifikasi', params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    verifikasi_email() {
      return new Promise(() => {
        Api.post('profile/verifikasi_email')
      })
    },
    update_pribadi({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('profile/update_data_pribadi', params)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    update_password({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('profile/update_password', params)
          .then((response) => {
            // Changing the password invalidates every token bound to the old hash
            // (other devices are logged out). The backend re-issues one for THIS
            // device — store it so the current session keeps working.
            const token = response.data && response.data.token
            if (token) {
              localStorage.setItem('token', token)
              Api.defaults.headers.common['Authorization'] = `Bearer ${token}`
            }
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateAvatar({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.post('profile/update_avatar', params, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {},
}

export default profile
